import { constants, typographyStyles } from "@newsela/angelou";

const { colors } = constants;
const { textM, textSObj } = typographyStyles;
const neutral600 = colors.ui.neutral[600];
const neutral700 = colors.ui.neutral[700];

export const writePromptContainerCss = {
  ...textM,
  padding: "24px",
  color: neutral700,
  overflowY: "auto",
};

export const headingCss = {
  color: neutral600,
  fontSize: textSObj.fontSize,
  fontWeight: "normal",
  margin: 0,
};

export const promptHeaderWrapperCss = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: "24px",
  marginBottom: "8px",
};

export const promptHeadingCss = {
  fontWeight: 700,
};
